import { DatePicker, Form, Input } from 'antd'
import CustomButton from "base/ui/components/Button"
import CustomSelect from 'base/ui/components/CustomSelect'
import { Filter } from 'base/ui/components/Icons'
import dayjs from 'dayjs'
import { observer } from 'mobx-react'
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox'
import { SearchModel } from 'pages/model'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CommonModel } from 'services/Main/common_services'
import { commonPresenter, commonStore } from 'stores/root_store'
import { DATE_FORMAT_POST, PAGE_SIZE_DEFAULT } from 'utils/constants'
import { customFilterOption } from 'utils/searchHelper'
import TableLastConsumer from './TableLastConsumer'
import { omit } from 'lodash'

// TAB NGƯỜI TIÊU DÙNG CUỐI
const { RangePicker } = DatePicker

type Props = {
  activeKey: string
}

const TabLastConsumer = ({ activeKey }: Props) => {
  //=====================================CHUYỂN NGÔN NGỮ=====================================//
  const { t } = useTranslation();
  const [form] = Form.useForm();
  // Tìm kiếm / phân trang
  const [dataSearch, setDataSearch] = useState<SearchModel>({
    paging: {
      pageSize: PAGE_SIZE_DEFAULT,
      pageIndex: 1,
      orderBy: undefined,
      orderByDesc: undefined,
    },
    config: 1,
    isReload: false,
    type: 'KH'
  });

  const [listWarrantyName, setListWarrantyName] = useState<CommonModel[]>([])


  // ===============================SEARCH BOX ==============================================================
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleGetWarrantyName = async () => {
    await commonPresenter.getListWarrantyName(commonStore)
    setListWarrantyName(commonStore.commonRespone.data)
  }

  useEffect(() => {
    handleGetWarrantyName()
  }, [])





  return (
    <div className='grid grid-cols-12 gap-default'>

      <div className='col-span-12 flex justify-end'>
        <CustomButton
          onClick={showDrawer}
          type="primary"
          color="#EFF4F9"
          className="!px-0 w-8"
        >
          <Filter className="!fill-primary" />
        </CustomButton>
      </div>

      <SearchBox
        onClose={onClose}
        open={open}
        className="lg:!w-[25%]"
        footer={
          <CustomButton
            htmlType="submit"
            className="my-auto ml-auto"
            type="primary"
            onClick={async () => {
              const value = form.getFieldsValue()
              const tempt: any = Object.fromEntries(Object.entries(value).filter(([_, value]) => {
                return !!value
              }))

              Object.assign(tempt, {
                config: 1,
                // ngày dự kiến bàn giao căn hộ
                ACXuatKhoFromDate: tempt.ACXuatKho?.[0] ? dayjs(tempt.ACXuatKho?.[0]).format(DATE_FORMAT_POST) : undefined,
                ACXuatKhoToDate: tempt.ACXuatKho?.[1] ? dayjs(tempt.ACXuatKho?.[1]).format(DATE_FORMAT_POST) : undefined,
                // ngày kích hoạt
                activeFromDate: tempt.activeDate?.[0] ? dayjs(tempt.activeDate?.[0]).format(DATE_FORMAT_POST) : undefined,
                activeToDate: tempt.activeDate?.[1] ? dayjs(tempt.activeDate?.[1]).format(DATE_FORMAT_POST) : undefined,
                //  ngày kết thúc bảo hành
                dateWarrantyEndFrom: tempt.endDateWarranty?.[0] ? dayjs(tempt.endDateWarranty?.[0]).format(DATE_FORMAT_POST) : undefined,
                dateWarrantyEndTo: tempt.endDateWarranty?.[1] ? dayjs(tempt.endDateWarranty?.[1]).format(DATE_FORMAT_POST) : undefined,


                isReload: true
              })

              const dataSend = omit(tempt, 'activeDate', 'endDateWarranty')
              setDataSearch({
                ...dataSend,
                paging: { ...dataSearch.paging, pageIndex: 1 },
              });
              form.submit();
              onClose();
            }}
          >
            {t("btn.search")}
          </CustomButton>
        }
      >
        <SearchForm
          form={form}
          column='col-1'
          initialValues={{
            type: 'KH'
          }}
        >
          {/* Số SO */}
          <SearchItem label={t('project-report.so-num')} name={'so'} >
            <Input />
          </SearchItem>
          {/* Serial SP */}
          <SearchItem label={'Serial SP'} name={'serial'} >
            <Input />
          </SearchItem>
          {/* Mã khách hàng */}
          <SearchItem label={t('project-report.customer-code')} name={'profileCode'} >
            <Input />
          </SearchItem>
          {/* Tên sản phẩm */}
          <SearchItem label={t('warranty-active.prd-name')} name={'productName'} >
            <Input />
          </SearchItem>

          {/* Tên bảo hành */}
          <SearchItem label={t('warranty-active.warranty-name')} name={'warrantyName'} >
            <CustomSelect
              options={listWarrantyName.map(item => {
                return {
                  label: item.value,
                  value: item.key
                }
              })}
              allowClear
              showSearch
              filterOption={customFilterOption}
            />
          </SearchItem>
          {/* Người kích hoạt */}
          <SearchItem label={t('warranty-active.active-person')} name={'type'} >
            <CustomSelect options={[
              { value: 'KH', label: 'Người tiêu dùng' },
              // { value: 'NPP', label: 'Nhà phân phối' },
              { value: null, label: 'An cường' },
            ]}
              showSearch
              filterOption={customFilterOption}
            />
          </SearchItem>
          {/* Ngày kích hoạt */}
          <SearchItem label={t('warranty-active.active-date')} name={'activeDate'} >
            <RangePicker
              placeholder={['Từ ngày', 'Đến ngày']}
              format="DD/MM/YYYY"
              className="w-full"
            />
          </SearchItem>
          {/* Ngày kết thúc bảo hành */}
          <SearchItem label={t('project-report.warranty-end-date')} name={'endDateWarranty'} >
            <RangePicker
              placeholder={['Từ ngày', 'Đến ngày']}
              format="DD/MM/YYYY"
              className="w-full"
            />
          </SearchItem>
          {/* Ngày AC xuất kho */}
          {/* <SearchItem label={'Ngày AC xuất kho'} name={'ACXuatKho'} >
            <RangePicker
              placeholder={['Từ ngày', 'Đến ngày']}
              format="DD/MM/YYYY"
              className="w-full"
            />
          </SearchItem> */}

        </SearchForm>
      </SearchBox>

      <div className='col-span-12 border-2 p-4 rounded bg-white'>
        <TableLastConsumer dataSearch={dataSearch} handleSearch={setDataSearch} />
      </div>
      {/* anh BA Phúc dặn ẩn không xóa */}
      {/* <div className='col-span-12 lg:col-span-6 border-2 p-4 rounded bg-white'>
        <ChartActiveRateByShowroom />
      </div>
      <div className='col-span-12 lg:col-span-6 border-2 p-4 rounded bg-white'>
        <ChartNumberOfProductConsumer />
      </div> */}
    </div>
  )
}

export default observer(TabLastConsumer)